// extracted by css-extract-rspack-plugin
export default {"sectionIcon":"sectionIcon-LR3FOW","educationList":"educationList-lRrkQn","section":"section-K69m27"};